<template>
  <div
    class="px-4 py-2.5 flex items-center justify-center rounded-3xl border whitespace-nowrap cursor-pointer"
    :class="{
      'text-white bg-dark  border-dark': isActive,
      'text-dark/75 bg-white border-[#E6E6E6] ': !isActive
    }"
    @click="$emit('click', chip)"
  >
    <span>{{ chip.name }}</span>
  </div>
</template>

<script>
export default {
  name: 'HubSectionsChipsItem',

  props: {
    chip: { type: Object, required: true },
    isActive: { type: Boolean, default: false }
  }
}
</script>
